export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ hxPurchaseStatus }) => {
      return !['N', 'R'].includes(hxPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ hxPurchaseStatus }) => {
      return !['N', 'R'].includes(hxPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ hxPurchaseStatus }) => {
      return !['N', 'R'].includes(hxPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_review') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'review',
    allow: 'Y',
    disabled: ({ hxPurchaseStatus }) => hxPurchaseStatus !== 'S',
  },
  {
    text: that.$l('menu_text_reject') || '审核驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'R',
    disabled: ({ hxPurchaseStatus }) => hxPurchaseStatus !== 'S',
  },
  {
    text: that.$l('menu_text_export') || '导出合同',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: true,
    allow: 'E',
    disabled: ({ hxPurchaseStatus }) => hxPurchaseStatus !== 'Y',
  },
  {
    text: that.$l('menu_text_binding_order') || '绑定订单',
    icon: 'el-icon-connection',
    menuType: 'binding',
    divided: true,
    allow: 'B',
    disabled: ({ hxPurchaseStatus, sourceBillNo }) => {
      return hxPurchaseStatus != 'Y' || !!sourceBillNo
    },
  },
]
